export default __webpack_public_path__ + "static/media/1-Cloudxier-CECTSustainabilityAwards1.0a271cd6.jpg";